export default {
    noRecordsYet: 'אין רישומים עדיין',
}
